<template>
  <div class="page_injuryTables">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div>
          <!-- <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
            <el-form-item label="险种名称" size="small">
              <el-input v-model="listQuery.InsuranceName" size="small" clearable></el-input>
            </el-form-item>
          </el-form> -->
        </div>
      </div>
      <div class="top-right">
        <!-- <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button> -->
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>工伤一览表</el-breadcrumb-item>
          <el-breadcrumb-item>客服-工伤手续办理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="add">&nbsp;新增+</el-button>
          <el-button type="danger" size="small" @click="syncOAData" v-if="roletype=='0383e791-72fd-4edc-aa70-2bcadminuser' || userid =='9c895257-5e33-4888-9bd8-adb6df000025'">&nbsp;OA数据同步</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column prop="Sort" label="序号" width="50" align="center" fixed="left">
            <template slot-scope="scope">
              {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="r.Idcard" label="身份证号码" width="155" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="r.TimeInjury" label="发生工伤日期" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="rw.InjuredEmployeeName" label="工伤员工姓名" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="rw.ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="rw.BranchOffice" label="分公司" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InjuryType" label="工伤类型" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.TimeApplyInjurReco" label="申请工伤认定时间" width="132" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Remark" label="申请工伤认定备注" width="130" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InjuryDeterminationConclusionTime" label="工伤认定结论时间" width="132" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Remark1" label="工伤认定结论备注" width="130" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.TimeApplyInjuryAssessment" label="申请工伤鉴定时间" width="130" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Remark2" label="申请工伤鉴定备注" width="130" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.WorkInjuryEvaluationTime" label="参加工伤鉴定时间" width="130" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Remark3" label="参加工伤鉴定备注" width="130" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InjuryAppraisalConclusionTime" label="工伤鉴定结论时间" width="125" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Remark4" label="工伤鉴定结论备注" width="130" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.IsApplyAppraisal" label="是否申请鉴定" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.DegreeDisability" label="伤残等级" width="80" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.ProcessingProgress" label="处理进度" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.IsSignAgreement" label="是否签署协议" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.CompletionInjuryTime" label="工伤完结时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Remark5" label="工伤完结情况备注" width="130" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.TimeSubmitReimburse" label="提交报销资料时间" width="130" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Remark6" label="提交报销资料备注" width="130" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InjuryMedicalExpenses" label="工伤医疗费" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InjuryCompensationCare" label="工伤护理费" width="130" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.HospitalFoodCost" label="工伤住院伙食补助费" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InjuryTransportCost" label="工伤交通费" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InjuryPay" label="工伤工资" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InjuryAppraisalFee" label="工伤鉴定费" width="150" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.OneTimeDisabilityBenefit" label="一次性伤残补助金" width="155" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.OneTimeWorkBenefit" label="一次性工伤医疗补助金" width="155" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.OneTimeDisabilityEmployBenefit" label="一次性伤残就业补助金" width="155" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.CompensationInjuryPacking" label="工伤打包款（加备注）" width="155" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.BenefitsWorkers" label="工亡待遇（加备注）" width="170" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.TotalAmountPaidOut" label="工伤赔付总金额" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InjuredEmployeeFileNum" label="工伤员工档案编号" width="170" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Remark11" label="备注1" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Remark12" label="备注2" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Remark13" label="备注3" width="120" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="r.Remark14" label="备注4" width="120" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="r.Remark15" label="备注5" width="120" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="110px">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="edit(row)">编辑</el-button>
                <el-popconfirm title="'请确定是否作废？'" @confirm="delAcd(row)" style="margin-left: 10px;">
                  <el-button type="text" slot="reference">作废</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="新增" :visible.sync="showAdd" width="1050px">
      <div class="formData">
        <el-form :model="formData" :inline="true" ref="formData" :rules="rules" label-width="170px">
          <el-form-item label="身份证号码" prop="Idcard">
            <el-input v-model.trim="formData.Idcard" style="width:300px" size="small" @blur="getIdcardInfo"></el-input>
          </el-form-item>
          <el-form-item label="发生工伤日期" prop="TimeInjury">
            <!-- <el-date-picker type="date" placeholder="" v-model="formData.TimeInjury" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker> -->
            <el-select v-model="formData.TimeInjury" placeholder="" clearable size="small" style="width:300px" value-key="Id" @change="changeTimeInjury">
              <el-option v-for="(item,index) in injuryDateList" :key="index" :label="item.TimeInjury" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工伤员工姓名">
            <el-input v-model="name" disabled readonly style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="项目名称">
            <el-input v-model="proName" disabled readonly style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="工伤类型" prop="InjuryType">
            <el-select v-model="formData.InjuryType" placeholder="" clearable size="small" style="width:300px">
              <el-option value="现场操作"></el-option>
              <el-option value="交通事故"></el-option>
              <el-option value="其他因素"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工伤员工档案编号" prop="InjuredEmployeeFileNum">
            <el-input v-model="formData.InjuredEmployeeFileNum" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="申请工伤认定时间" prop="TimeApplyInjurReco">
            <el-date-picker type="date" placeholder="" v-model="formData.TimeApplyInjurReco" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="申请工伤认定备注" prop="Remark">
            <el-input v-model="formData.Remark" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="工伤认定结论时间" prop="InjuryDeterminationConclusionTime">
            <el-date-picker type="date" placeholder="" v-model="formData.InjuryDeterminationConclusionTime" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="工伤认定结论备注" prop="Remark1">
            <el-input v-model="formData.Remark1" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="申请工伤鉴定时间" prop="TimeApplyInjuryAssessment">
            <el-date-picker type="date" placeholder="" v-model="formData.TimeApplyInjuryAssessment" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="申请工伤鉴定备注" prop="Remark2">
            <el-input v-model="formData.Remark2" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="参加工伤鉴定时间" prop="WorkInjuryEvaluationTime">
            <el-date-picker type="date" placeholder="" v-model="formData.WorkInjuryEvaluationTime" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="参加工伤鉴定备注" prop="Remark3">
            <el-input v-model="formData.Remark3" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="工伤鉴定结论时间" prop="InjuryAppraisalConclusionTime">
            <el-date-picker type="date" placeholder="" v-model="formData.InjuryAppraisalConclusionTime" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="工伤鉴定结论备注" prop="Remark4">
            <el-input v-model="formData.Remark4" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="是否申请鉴定" prop="IsApplyAppraisal">
            <el-select v-model="formData.IsApplyAppraisal" placeholder="" clearable size="small" style="width:300px">
              <el-option value="是"></el-option>
              <el-option value="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="伤残等级" prop="DegreeDisability">
            <el-select v-model="formData.DegreeDisability" placeholder="" clearable size="small" style="width:300px">
              <el-option value="无"></el-option>
              <el-option value="十级"></el-option>
              <el-option value="九级"></el-option>
              <el-option value="八级"></el-option>
              <el-option value="七级"></el-option>
              <el-option value="六级"></el-option>
              <el-option value="五级"></el-option>
              <el-option value="四级"></el-option>
              <el-option value="三级"></el-option>
              <el-option value="二级"></el-option>
              <el-option value="一级"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处理进度" prop="ProcessingProgress">
            <el-select v-model="formData.ProcessingProgress" placeholder="" clearable size="small" style="width:300px">
              <el-option value="尚在处理"></el-option>
              <el-option value="处理完结"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否签署协议" prop="IsSignAgreement">
            <el-select v-model="formData.IsSignAgreement" placeholder="" clearable size="small" style="width:300px">
              <el-option value="否"></el-option>
              <el-option value="是，调解协议"></el-option>
              <el-option value="是，仲裁调解"></el-option>
              <el-option value="是，仲裁裁决"></el-option>
              <el-option value="是，法院调解"></el-option>
              <el-option value="是，法院判决"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工伤完结时间" prop="CompletionInjuryTime">
            <el-date-picker type="date" placeholder="" v-model="formData.CompletionInjuryTime" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="工伤完结情况备注" prop="Remark5">
            <el-input v-model="formData.Remark5" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="提交报销资料时间" prop="TimeSubmitReimburse">
            <el-date-picker type="date" placeholder="" v-model="formData.TimeSubmitReimburse" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="提交报销资料备注" prop="Remark6">
            <el-input v-model="formData.Remark6" style="width:300px" size="small"></el-input>
          </el-form-item>
          <div v-if="type=='edit'">
            <el-form-item label="工伤医疗费" prop="InjuryMedicalExpenses">
              <el-input v-model="formData.InjuryMedicalExpenses" style="width:300px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="工伤护理费" prop="InjuryCompensationCare">
              <el-input v-model="formData.InjuryCompensationCare" style="width:300px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="工伤住院伙食补助费" prop="HospitalFoodCost">
              <el-input v-model="formData.HospitalFoodCost" style="width:300px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="工伤交通费" prop="InjuryTransportCost">
              <el-input v-model="formData.InjuryTransportCost" style="width:300px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="工伤工资" prop="InjuryPay">
              <el-input v-model="formData.InjuryPay" style="width:300px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="工伤鉴定费" prop="InjuryAppraisalFee">
              <el-input v-model="formData.InjuryAppraisalFee" style="width:300px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="一次性伤残补助金" prop="OneTimeDisabilityBenefit">
              <el-input v-model="formData.OneTimeDisabilityBenefit" style="width:300px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="一次性工伤医疗补助金" prop="OneTimeWorkBenefit">
              <el-input v-model="formData.OneTimeWorkBenefit" style="width:300px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="一次性伤残就业补助金" prop="OneTimeDisabilityEmployBenefit">
              <el-input v-model="formData.OneTimeDisabilityEmployBenefit" style="width:300px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="工伤打包款（加备注）" prop="CompensationInjuryPacking">
              <el-input v-model="formData.CompensationInjuryPacking" style="width:300px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="工亡待遇（加备注）" prop="BenefitsWorkers">
              <el-input v-model="formData.BenefitsWorkers" style="width:300px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="工伤赔付总金额" prop="TotalAmountPaidOut">
              <el-input v-model="formData.TotalAmountPaidOut" style="width:300px" size="small"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="备注1">
            <el-input v-model="formData.Remark11" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="备注2">
            <el-input v-model="formData.Remark12" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="备注3">
            <el-input v-model="formData.Remark13" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="备注4">
            <el-input v-model="formData.Remark14" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="备注5">
            <el-input v-model="formData.Remark15" style="width:300px" size="small"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAdd = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmSubmit">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择同步月份" :visible.sync="showSync" width="500px">
      <el-form label-width="80px">
        <el-form-item label="同步月份" prop="OAMonth">
          <el-date-picker v-model="OAMonth" type="month" value-format="yyyy-MM" size="small" style="width: 300px;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSync = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmSyncOAData">提 交</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import FUN from "../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    nextTick
  } from 'vue';
  export default {
    data() {
      return {
        listQuery: {
          pageNum: 1,
          pageSize: 10,
        },
        tableData: [],
        totalCount: 0,
        loading: false,
        showAdd: false,
        type: '',
        userid:Cookies.get("userid-b"),
        roletype:localStorage.loginRoletype,
        formData: {
          Id: '',
          Idcard: '', //身份证号码
          TimeInjury: '', //发生工伤时间（年-月-日）
          InjuryType: '', //工伤类型
          TimeApplyInjurReco: '', //申请工伤认定时间
          Remark: '', //备注
          InjuryDeterminationConclusionTime: '', //工伤认定结论时间
          Remark1: '', //备注1
          TimeApplyInjuryAssessment: '', //申请工伤鉴定时间
          Remark2: '', //备注2
          WorkInjuryEvaluationTime: '', //参加工伤鉴定时间
          Remark3: '', //备注3
          InjuryAppraisalConclusionTime: '', //工伤鉴定结论时间
          Remark4: '', //备注4
          IsApplyAppraisal: '', //是否申请鉴定
          DegreeDisability: '', //伤残等级
          ProcessingProgress: '', //处理进度
          IsSignAgreement: '', //是否签署协议
          CompletionInjuryTime: '', //工伤完结时间
          Remark5: '', //备注5
          TimeSubmitReimburse: '', //提交报销资料时间
          Remark6: '', //备注6
          InjuryMedicalExpenses: '', //工伤医疗费
          InjuryCompensationCare: '', //工伤护理费
          HospitalFoodCost: '', //工伤住院伙食补助费
          InjuryTransportCost: '', //工伤交通费
          InjuryPay: '', //工伤工资
          InjuryAppraisalFee: '', //工伤鉴定费
          OneTimeDisabilityBenefit: '', //一次性伤残补助金
          OneTimeWorkBenefit: '', //一次性工伤医疗补助金
          OneTimeDisabilityEmployBenefit: '', //一次性伤残就业补助金
          CompensationInjuryPacking: '', //工伤打包款（加备注）
          BenefitsWorkers: '', //工亡待遇（加备注）
          TotalAmountPaidOut: '', //工伤赔付总金额
          InjuredEmployeeFileNum: '', //工伤员工档案编号
          Remark11: '', //备注1
          Remark12: '', //备注2
          Remark13: '', //备注3
          Remark14: '', //备注4
          Remark15: '', //备注5
        },
        rules: {
          Idcard: {
            required: true,
            message: '请输入身份证号码',
            trigger: 'blur'
          },
          TimeInjury: {
            required: true,
            message: '请选择发生工伤时间（年-月-日）',
            trigger: 'change'
          },
          InjuryType: {
            required: true,
            message: '请选择工伤类型',
            trigger: 'change'
          },
          TimeApplyInjurReco: {
            required: true,
            message: '请选择申请工伤认定时间',
            trigger: 'change'
          },
          Remark: {
            required: true,
            message: '请输入备注',
            trigger: 'blur'
          },
          InjuryDeterminationConclusionTime: {
            required: true,
            message: '请选择工伤认定结论时间',
            trigger: 'change'
          },
          Remark1: {
            required: true,
            message: '请输入备注1',
            trigger: 'blur'
          },
          TimeApplyInjuryAssessment: {
            required: true,
            message: '请选择申请工伤鉴定时间',
            trigger: 'change'
          },
          Remark2: {
            required: true,
            message: '请输入备注2',
            trigger: 'blur'
          },
          WorkInjuryEvaluationTime: {
            required: true,
            message: '请选择参加工伤鉴定时间',
            trigger: 'change'
          },
          Remark3: {
            required: true,
            message: '请输入备注3',
            trigger: 'blur'
          },
          InjuryAppraisalConclusionTime: {
            required: true,
            message: '请选择工伤鉴定结论时间',
            trigger: 'change'
          },
          Remark4: {
            required: true,
            message: '请输入备注4',
            trigger: 'blur'
          },
          IsApplyAppraisal: {
            required: true,
            message: '请选择是否申请鉴定',
            trigger: 'change'
          },
          DegreeDisability: {
            required: true,
            message: '请选择伤残等级',
            trigger: 'change'
          },
          ProcessingProgress: {
            required: true,
            message: '请选择处理进度',
            trigger: 'change'
          },
          IsSignAgreement: {
            required: true,
            message: '请选择是否签署协议',
            trigger: 'change'
          },
          CompletionInjuryTime: {
            required: true,
            message: '请选择工伤完结时间',
            trigger: 'change'
          },
          Remark5: {
            required: true,
            message: '请输入备注5',
            trigger: 'blur'
          },
          TimeSubmitReimburse: {
            required: true,
            message: '请选择提交报销资料时间',
            trigger: 'change'
          },
          Remark6: {
            required: true,
            message: '请输入备注6',
            trigger: 'blur'
          },
          InjuryMedicalExpenses: {
            required: true,
            message: '请输入工伤医疗费',
            trigger: 'blur'
          },
          InjuryCompensationCare: {
            required: true,
            message: '请输入工伤护理费',
            trigger: 'blur'
          },
          HospitalFoodCost: {
            required: true,
            message: '请输入工伤住院伙食补助费',
            trigger: 'blur'
          },
          InjuryTransportCost: {
            required: true,
            message: '请输入工伤住院伙食补助费',
            trigger: 'blur'
          },
          InjuryTransportCost: {
            required: true,
            message: '请输入工伤交通费',
            trigger: 'blur'
          },
          InjuryPay: {
            required: true,
            message: '请输入工伤工资',
            trigger: 'blur'
          },
          InjuryAppraisalFee: {
            required: true,
            message: '请输入工伤鉴定费',
            trigger: 'blur'
          },
          OneTimeDisabilityBenefit: {
            required: true,
            message: '请输入一次性伤残补助金',
            trigger: 'blur'
          },
          OneTimeWorkBenefit: {
            required: true,
            message: '请输入一次性工伤医疗补助金',
            trigger: 'blur'
          },
          OneTimeDisabilityEmployBenefit: {
            required: true,
            message: '请输入一次性伤残就业补助金',
            trigger: 'blur'
          },
          CompensationInjuryPacking: {
            required: true,
            message: '请输入工伤打包款（加备注）',
            trigger: 'blur'
          },
          BenefitsWorkers: {
            required: true,
            message: '请输入工亡待遇（加备注）',
            trigger: 'blur'
          },
          TotalAmountPaidOut: {
            required: true,
            message: '请输入工伤赔付总金额',
            trigger: 'blur'
          },
          InjuredEmployeeFileNum: {
            required: true,
            message: '请输入工伤员工档案编号',
            trigger: 'blur'
          },
          Remark11: {
            required: true,
            message: '请输入备注1',
            trigger: 'blur'
          },
          Remark12: {
            required: true,
            message: '请输入备注2',
            trigger: 'blur'
          },
          Remark13: {
            required: true,
            message: '请输入备注3',
            trigger: 'blur'
          },
          Remark14: {
            required: true,
            message: '请输入备注4',
            trigger: 'blur'
          },
          Remark15: {
            required: true,
            message: '请输入备注5',
            trigger: 'blur'
          },
        },
        injuryDateList: [], //工伤日期列表
        name: '',
        proName: '',
        OAMonth: '',
        showSync: false,
      }
    },
    created() {
      this.getWiserviceList();
    },
    methods: {
      checkPermission,
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getWiserviceList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getWiserviceList();
      },
      //取客服部-工伤手续办理列表
      getWiserviceList() {
        this.loading = true;
        xz.getWiserviceList(this.listQuery, this.roletype).then(res => {
          if (res.status == "ok") {
            console.log(res.data.data)
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
            this.loading = false;
          } else {
            this.loading = false;
            this.tableData = [];
          }
        })
      },
      searchHandle() {
        this.listQuery.pageNum = 1;
        this.getWiserviceList()
      },
      add() {
        this.type = 'add';
        this.clearForm();
        this.showAdd = true;
      },
      edit(item) {
        console.log(item)
        this.type = 'edit';
        if (item.rw && item.rw.InjuredEmployeeName != undefined) {
          this.name = item.rw.InjuredEmployeeName;
          this.proName = item.rw.ProjectName;
          xz.getWiserviceReport(item.r.Id, this.roletype).then(res => {
            if (res.status == "ok") {
              this.formData = res.data;
            } else {
              this.formData = item;
            }
            this.showAdd = true;
          })
        } else {
          this.$message.warning('请先添加工伤事故报告信息')
        }
      },
      clearForm() {
        this.name = '';
        this.proName = '';
        this.formData = {
          Id: '',
          Idcard: '', //身份证号码
          TimeInjury: '', //发生工伤时间（年-月-日）
          InjuryType: '', //工伤类型
          TimeApplyInjurReco: '', //申请工伤认定时间
          Remark: '', //备注
          InjuryDeterminationConclusionTime: '', //工伤认定结论时间
          Remark1: '', //备注1
          TimeApplyInjuryAssessment: '', //申请工伤鉴定时间
          Remark2: '', //备注2
          WorkInjuryEvaluationTime: '', //参加工伤鉴定时间
          Remark3: '', //备注3
          InjuryAppraisalConclusionTime: '', //工伤鉴定结论时间
          Remark4: '', //备注4
          IsApplyAppraisal: '', //是否申请鉴定
          DegreeDisability: '', //伤残等级
          ProcessingProgress: '', //处理进度
          IsSignAgreement: '', //是否签署协议
          CompletionInjuryTime: '', //工伤完结时间
          Remark5: '', //备注5
          TimeSubmitReimburse: '', //提交报销资料时间
          Remark6: '', //备注6
          InjuryMedicalExpenses: '', //工伤医疗费
          InjuryCompensationCare: '', //工伤护理费
          HospitalFoodCost: '', //工伤住院伙食补助费
          InjuryTransportCost: '', //工伤交通费
          InjuryPay: '', //工伤工资
          InjuryAppraisalFee: '', //工伤鉴定费
          OneTimeDisabilityBenefit: '', //一次性伤残补助金
          OneTimeWorkBenefit: '', //一次性工伤医疗补助金
          OneTimeDisabilityEmployBenefit: '', //一次性伤残就业补助金
          CompensationInjuryPacking: '', //工伤打包款（加备注）
          BenefitsWorkers: '', //工亡待遇（加备注）
          TotalAmountPaidOut: '', //工伤赔付总金额
          InjuredEmployeeFileNum: '', //工伤员工档案编号
          Remark11: '', //备注1
          Remark12: '', //备注2
          Remark13: '', //备注3
          Remark14: '', //备注4
          Remark15: '', //备注5
        }
      },
      //新增/修改
      confirmSubmit() {
        this.$refs["formData"].validate((valid) => {
          if (valid) {
            xz.updataWiservice(this.formData, this.roletype).then(res => {
              if (res.status == "ok") {
                this.showAdd = false;
                this.getWiserviceList();
                this.$message.success('新增成功！')
              } else {
                this.showAdd = false;
                this.$message.error(res.msg)
              }
            })
          }
        })
      },
      del(item) {
        xz.delWiservice(item.r.Id, this.roletype).then(res => {
          if (res.status == "ok") {
            this.getWiserviceList();
            this.$message.success('作废成功！')
          } else {
            this.getWiserviceList();
            this.$message.error(res.msg)
          }
        })
      },
      getIdcardInfo() {
        if (this.formData.Idcard.length == 18) {
          let data = {
            pageNum: 1,
            pageSize: 1000,
            Idcard: this.formData.Idcard
          }
          xz.getWIAccidentReportList(data, this.roletype).then(res => {
            if (res.status == "ok") {
              if (res.data.data.length > 0) {
                this.injuryDateList = res.data.data;
              } else {
                this.injuryDateList = [];
                this.$message.error('请先添加工伤事故报告信息')
              }
            } else {
              this.injuryDateList = [];
              this.$message.error('获取身份证信息失败')
            }
          })
        }
      },
      changeTimeInjury(val) {
        this.formData.TimeInjury = val.TimeInjury;
        this.name = val.InjuredEmployeeName;
        this.proName = val.ProjectName;
      },
      syncOAData() {
        this.OAMonth = '';
        this.showSync = true;
      },
      confirmSyncOAData() {
        if (this.OAMonth) {
          xz.getOACostDetail(this.OAMonth, this.roletype).then(res => {
            if (res.status == "ok") {
              this.$message.success('同步中，数据更新可能有延迟')
              this.showSync = false;
            } else {
              this.$message.error(res.msg)
              this.showSync = false;
            }
          })
        } else {
          this.$message.warning('请选择同步月份')
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }
</style>
<style>
  .page_injuryTables .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_injuryTables .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_injuryTables .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_injuryTables .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_injuryTables .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_injuryTables .formData .el-form-item {
    margin-bottom: 10px;
  }

  .page_injuryTables .formData .el-form-item__error {
    top: 34px;
  }

  .page_injuryTables .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>